import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'detachPermissionTagGroup';
export const useDetachPermissionTagGroupTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Открепление группы',
    description: 'Выберите новый тег доступа для группы {{groupName}}.',
    permission_tag: 'Тег доступа',
    placeholder: 'Выберите',
    empty: 'Нет доступных тегов',
    load_error: 'Не удалось загрузить данные',
    submit: 'Сохранить',
    cancel: 'Отмена',
    on_success: 'Группа успешно откреплена',
    on_error: 'Не удалось открепить группу',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Detach group',
    description: 'Select a new permission tag for the {{groupName}} group.',
    permission_tag: 'Permission tag',
    placeholder: 'Select',
    empty: 'No tags available',
    load_error: 'Failed to load data',
    submit: 'Save',
    cancel: 'Cancel',
    on_success: 'Group detached successfully',
    on_error: 'Failed to detach group',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Desvincular grupo',
    description: 'Seleccione una nueva etiqueta de acceso para el grupo {{groupName}}.',
    permission_tag: 'Etiqueta de acceso',
    placeholder: 'Seleccionar',
    empty: 'No hay etiquetas disponibles',
    load_error: 'No se pudieron cargar los datos',
    submit: 'Guardar',
    cancel: 'Cancelar',
    on_success: 'El grupo se desvinculó correctamente',
    on_error: 'No se pudo desvincular el grupo',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Desvincular grupo',
    description: 'Selecione uma nova etiqueta de acesso para o grupo {{groupName}}.',
    permission_tag: 'Etiqueta de acesso',
    placeholder: 'Selecionar',
    empty: 'Nenhuma etiqueta disponível',
    load_error: 'Falha ao carregar os dados',
    submit: 'Salvar',
    cancel: 'Cancelar',
    on_success: 'Grupo desvinculado com sucesso',
    on_error: 'Não foi possível desvincular o grupo',
  },
}) : {}) as Record<string, unknown>;
